// import components
import ProtectedRoutes from "./components/ProtectedRoutes";
import E404 from "./pages/E404";
import Login from "./pages/Login";

// import utils
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { routes } from "./utils/routes";
import { Toaster } from "react-hot-toast";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getCookie, setCookie } from "./utils/functions";
import { getCategories, setAuth } from "./redux/slicers/config";
import { QueryClient, QueryClientProvider } from "react-query";
import userServices from "./services/users";
import { Suspense } from "react";
import DSpinner from "./components/DSpinner";
import WattingPage from "./pages/WattingPage";
// import DSpinner from "./components/DSpinner";

const queryClient = new QueryClient();
const theme = extendTheme({
  fonts: {
    body: "Cairo-Medium ,  Arial, Helvetica, sans-serif",
    heading: "Cairo-Medium ,  Arial, Helvetica, sans-serif",
  },
  colors: {
    primary: {
      100: "#f7fafc",
    },
  },
});
function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const interval = useRef();
  useEffect(() => {
    const checkAuth = () => {
      userServices.getAllUsers().catch((err) => {
        setCookie("dc-auth", "", -1);
        dispatch(setAuth({}));
        navigate("/login", { replace: true });
      });
    };

    if (
      JSON.parse(window.localStorage.getItem("dc-auth")) &&
      getCookie("dc-auth")
    ) {
      const auth = JSON.parse(window.localStorage.getItem("dc-auth"));
      if (auth.role === "admin") {
        // userServices.getMyInfo();
        dispatch(setAuth(JSON.parse(window.localStorage.getItem("dc-auth"))));
        checkAuth();
        dispatch(getCategories());
        // dispatch(getProgressOrders());
        interval.current = setInterval(checkAuth, 60 * 1000);
      } else {
        // setCookie("dc-auth", "", -1);
        // dispatch(setAuth({}));
        // navigate("/login", { replace: true });
      }
    } else {
      // clearInterval(interval.current);
      // setCookie("dc-auth", "", -1);
      // dispatch(setAuth({}));
      // navigate("/login", { replace: true });
    }
    return () => {
      clearInterval(interval.current);
    };
  }, [dispatch, navigate]);
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <Toaster />
        <div className="App text-third-color">
          <Routes>
            <Route element={<ProtectedRoutes />}>
              {routes.map((r) => {
                if (r.children) {
                  return r.children.map((c) => <Route key={c.id} {...c} />);
                }
                return <Route key={r.id} {...r} />;
              })}
              <Route
                path="/login"
                element={<Login title="لوحة التحكم | تسجيل الدخول" />}
              />
            </Route>
            <Route path="*" element={<E404 />} />
            <Route path="/wating-page" element={<WattingPage />} />
          </Routes>
        </div>
      </ChakraProvider>
    </QueryClientProvider>
  );
}

export default App;
